import React from "react";
import Icon from "@ant-design/icons";
const ProjectSvg = ({ width = "1rem", height = "1rem", fill = "none" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill={fill}
		>
			<path
				d="M13.1667 2.0013C13.5203 2.0013 13.8594 2.14178 14.1095 2.39183C14.3595 2.64187 14.5 2.98101 14.5 3.33464V12.668C14.5 13.0216 14.3595 13.3607 14.1095 13.6108C13.8594 13.8608 13.5203 14.0013 13.1667 14.0013H3.83333C3.47971 14.0013 3.14057 13.8608 2.89052 13.6108C2.64048 13.3607 2.5 13.0216 2.5 12.668V3.33464C2.5 2.98101 2.64048 2.64187 2.89052 2.39183C3.14057 2.14178 3.47971 2.0013 3.83333 2.0013H6.62C6.9 1.22797 7.63333 0.667969 8.5 0.667969C9.36667 0.667969 10.1 1.22797 10.38 2.0013H13.1667ZM8.5 2.0013C8.32319 2.0013 8.15362 2.07154 8.0286 2.19656C7.90357 2.32159 7.83333 2.49116 7.83333 2.66797C7.83333 2.84478 7.90357 3.01435 8.0286 3.13937C8.15362 3.2644 8.32319 3.33464 8.5 3.33464C8.67681 3.33464 8.84638 3.2644 8.9714 3.13937C9.09643 3.01435 9.16667 2.84478 9.16667 2.66797C9.16667 2.49116 9.09643 2.32159 8.9714 2.19656C8.84638 2.07154 8.67681 2.0013 8.5 2.0013ZM5.16667 4.66797V3.33464H3.83333V12.668H13.1667V3.33464H11.8333V4.66797H5.16667ZM8.5 6.0013C8.85362 6.0013 9.19276 6.14178 9.44281 6.39183C9.69286 6.64188 9.83333 6.98101 9.83333 7.33464C9.83333 7.68826 9.69286 8.0274 9.44281 8.27744C9.19276 8.52749 8.85362 8.66797 8.5 8.66797C8.14638 8.66797 7.80724 8.52749 7.55719 8.27744C7.30714 8.0274 7.16667 7.68826 7.16667 7.33464C7.16667 6.98101 7.30714 6.64188 7.55719 6.39183C7.80724 6.14178 8.14638 6.0013 8.5 6.0013ZM5.83333 11.3346V10.668C5.83333 9.93464 7.02667 9.33464 8.5 9.33464C9.97333 9.33464 11.1667 9.93464 11.1667 10.668V11.3346H5.83333Z"
				fill="#9E9E9E"
			/>
		</svg>
	);
};
const ProjectIcon = (props) => (
	<Icon component={() => <ProjectSvg {...props} />} />
);

export default ProjectIcon;
